import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldLabel, FormField } from '../styled';

interface TitleFieldProps {
  hideArea?: boolean;
  value: string;
  onChange: (value: string) => void;
}

const TitleField = ({ hideArea, value, onChange }: TitleFieldProps) => {
  const { t } = useTranslation('common');

  return (
  <FormField>
    <FieldLabel>
      {hideArea
        ? t('assistant.ragStorageDialog.title')
        : t('assistant.ragStorageDialog.area')}
    </FieldLabel>
    <TextField
      fullWidth
      disabled={!hideArea}
      value={value}
      onChange={hideArea ? (e) => onChange(e.target.value) : undefined}
      inputProps={{ 'data-testid': 'context-dialog-title-input' }}
      sx={{
        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: 'var(--am-text-primary)',
        },
      }}
    />
  </FormField>
  );
};

export default TitleField;
